import { useCallback, useEffect, useState } from 'react'

const STORAGE_PREFIX = 'waitlist:'
const BASE_COUNT = 214

/** Cupos totales de la primera tanda (escasez, sin fecha de lanzamiento). */
export const SPOTS_TOTAL = 500

function countRecords(): number {
  if (typeof window === 'undefined') return 0
  let n = 0
  for (let i = 0; i < window.localStorage.length; i++) {
    const key = window.localStorage.key(i)
    if (key && key.startsWith(STORAGE_PREFIX)) n++
  }
  return n
}

/**
 * Contador de la lista de espera, usado como prueba social.
 * Los registros reales ahora se capturan en Typeform; este contador
 * muestra la base + cualquier registro previo guardado localmente.
 */
export function useWaitlistCount() {
  const [count, setCount] = useState<number | null>(null)

  const refresh = useCallback(() => {
    setCount(BASE_COUNT + countRecords())
  }, [])

  useEffect(() => {
    refresh()
    const onStorage = () => refresh()
    window.addEventListener('storage', onStorage)
    return () => window.removeEventListener('storage', onStorage)
  }, [refresh])

  return { count }
}
